<template>
  <div class="single d-flex align-items-center">
    <span v-if="!jobAd.anonymize">
      <img
        :src="`https://jobshark.eu/storage/employers/logos/${jobAd.employer_photo}`"
        v-if="
          jobAd.employer_photo !== null &&
            jobAd.employer_photo !== 'default.png' &&
            jobAd.employer_photo !== 'null' &&
            jobAd.employer_photo !== ''
        "
        :title="jobAd.title"
      />
      <img :src="require(`../../../public/img/comstream.svg`)" v-else :title="jobAd.title" />
    </span>
    <img
      v-else
      :src="require(`../../../public/img/homepage/customer-logos/comstream-logo.png`)"
      :alt="jobAd.title"
    />
    <div class="job-info">
      <router-link
        :to="{
          name: 'preview-job-ad',
          params: { slug: jobAd.slug },
        }"
        >{{ jobAd.title }}</router-link
      >
      <a href="#">{{ jobAd.employer_name }}</a>
    </div>
    <div
      class="location"
      v-if="jobAd.address.hasOwnProperty('city') && jobAd.address.hasOwnProperty('country')"
    >
      <i class="fas fa-map-marker-alt"></i>
      <span>{{ jobAd.address.city.name }}, {{ jobAd.address.country.name }}</span>
    </div>
    <div class="location">
      <i class="fas fa-handshake"></i>
      <span>{{ employmentType(jobAd.employment_type) }}</span>
    </div>
    <div class="location">
      <i class="fas fa-briefcase"></i>
      <span>{{ showWorkPlace(jobAd.workplace) }}</span>
    </div>
    <div
      v-if="() => jobAd.required_competences.lenght > 0"
      class="tagline ml-auto dropdown dropstart"
    >
      <a v-for="subCompetence in requiredCompetences" :key="subCompetence.id" href="#">{{
        subCompetence.name
      }}</a>
      <a
        v-if="moreThanFour"
        class="show-more"
        href="#"
        role="button"
        :id="`dropdownMenuLink-${jobAd.id}`"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i class="fas fa-ellipsis-h"></i>
      </a>
      <ul v-if="moreThanFour" class="dropdown-menu" aria-labelledby="dropdownMenuLink">
        <a
          v-for="subCompetenceAdvantage in advantageCompetences"
          :key="subCompetenceAdvantage.id"
          href="#"
          >{{ subCompetenceAdvantage.name }}</a
        >
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    jobAd: Object,
  },
  data: () => ({
    moreThanFour: false,
    requiredCompetences: [],
    advantageCompetences: [],
  }),
  methods: {
    showWorkPlace(data) {
      if (data === 1) {
        return 'Onsite';
      } else if (data === 2) {
        return 'Hybrid';
      } else {
        return 'Remote';
      }
    },
    employmentType(employment) {
      if (employment === 1) {
        return 'Employment';
      } else if (employment === 2) {
        return 'Self-employment';
      } else if (employment === 3) {
        return 'Employment / Self-Employment';
      }
    },
    sliceCompetences(required, advantage) {
      let allCompetences = required.concat(advantage);
      this.requiredCompetences = allCompetences.slice(0, 4);
      if (allCompetences.length > 4) {
        this.moreThanFour = true;
        this.advantageCompetences = allCompetences.slice(4);
      }
    },
    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
  },
  mounted() {
    this.sliceCompetences(this.jobAd.required_competences, this.jobAd.advantage_competences);
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';
.single {
  padding: 5px;
  background: #fff;
  box-shadow: 0px 15px 35px #0000000d;
  margin-bottom: 20px;
  font-family: $font-family-sans-lato;
  img {
    width: 70px;
    height: 70px;
    object-fit: contain;
    object-position: center;
    overflow: hidden;
    margin-right: 12px;
    flex-shrink: 0;
  }
  .job-info {
    width: 37%;
    margin-right: 12px;
    a {
      display: block;
      text-decoration: none;
      &:first-of-type {
        font-size: 18px;
      }
      &:nth-of-type(2) {
        color: #424242;
        font-size: 16px;
      }
    }
  }
  .location {
    text-align: center;
    width: 130px;
    margin: 0 10px;
    a {
      text-decoration: none;
    }
    i {
      display: block;
      color: #afafaf;
      font-size: 18px;
      margin-bottom: 5px;
    }
    span {
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      text-transform: uppercase;
    }
  }
  .tagline {
    text-align: right;
    width: 200px;
    a {
      display: inline-block;
      background: #f2f2f2;
      border-radius: 16px;
      color: #3e3e3e;
      border: 5px solid #fff;
      font-size: 13px;
      padding: 3px 8px;
      text-decoration: none;
      font-weight: 500;
    }
    .show-more {
      background: none;
      font-size: 11px;
    }
  }
}
</style>
